/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import LoginLinkSectionDumb from './LoginLinkSectionDumb';
import { resetSupportLoginLink } from 'src/shared/app/authentication/action/support/supportLoginLinkActions';
import { isLoginLinkSent } from 'src/shared/app/authentication/selector/support/appLoginLinkSelector';
import withMount from 'src/shared/app/base/component/hoc/withMount';

import type { State } from 'src/shared/core/type/reduxTypes';

const mapStateToProps = (state: State): Object => ({
  isLinkSent: isLoginLinkSent(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => ({
  ...stateProps,
  handleMount() {
    dispatch(resetSupportLoginLink());
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withMount,
)(LoginLinkSectionDumb);
